import _extends from "@babel/runtime/helpers/esm/extends";
import { useGridRootProps } from "../../hooks/utils/useGridRootProps.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
function GridHeaderFilterClearButton(props) {
  const rootProps = useGridRootProps();
  return /*#__PURE__*/_jsx(rootProps.slots.baseIconButton, _extends({
    tabIndex: -1,
    "aria-label": "Clear filter",
    size: "small"
  }, rootProps.slotProps?.baseIconButton, props, {
    children: /*#__PURE__*/_jsx(rootProps.slots.columnMenuClearIcon, {
      fontSize: "inherit"
    })
  }));
}
export { GridHeaderFilterClearButton };